<template>
    <Alert
        type="danger"
        title="Error"
    >
        An unexpected error happened, please talk to us.
    </Alert>
</template>

<script setup lang="ts">
    import Alert from '@/Shared/Component/Alert.vue'
</script>
